module.exports = __webpack_public_path__ + "5ce70f19df9b7eca2052bfbd49c13bf4.jpg";